import { render, staticRenderFns } from "./summary-subtitle.vue?vue&type=template&id=8723d7f4&scoped=true"
import script from "./summary-subtitle.vue?vue&type=script&lang=ts"
export * from "./summary-subtitle.vue?vue&type=script&lang=ts"
import style0 from "./summary-subtitle.vue?vue&type=style&index=0&id=8723d7f4&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8723d7f4",
  null
  
)

export default component.exports